import type { SearchParams } from './types';

export const emitSearchAssetsEvent = (params: SearchParams) => {
	const searchAssetsEvent = new CustomEvent('react-overview_search-assets', {
		detail: { filters: params },
	});

	window.dispatchEvent(searchAssetsEvent);
};
